module.exports = __webpack_public_path__ + "static/media/logo-SOC.e0487e8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-logos/logo-SOC.jpg
// module id = 2324
// module chunks = 17